import React, {Component, Fragment, useState} from 'react';

import {
    uploadLocalPagesCsv
} from "../manageLocations/localPages/LocalPagesApi";
import { ToastService } from '../../../components/toasts/Toasts';

class LocalPagesUploader extends Component {

    state = {

        // Initially, no file is selected
        selectedFile: null,
        fileUploading: false,
        buttonEnabled: false,
        errorMessage: null,
        successCountMessage: null
    };

    // On file select (from the pop up)
    onFileChange = event => {

        // Update the state
        this.setState({ selectedFile: event.target.files[0] });
        this.setState({ buttonEnabled: true });
        this.setState({successCountMessage: null})
        this.setState({errorMessage: null})

    };

    // On file upload (click the upload button)
    onFileUpload = () => {

        this.setState({fileUploading: true})

        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
            "myFile",
            this.state.selectedFile,
            this.state.selectedFile.name
        );

        // Request made to the backend api
        // Send formData object
        uploadLocalPagesCsv(formData)
            .then(resp => {
                this.setState({fileUploading: false})
                this.setState({successCountMessage: resp.localPageLocationDocumentsAddedOrUploaded})
                this.setState({ buttonEnabled: false });
                ToastService.success(`Successfully Added/Updated: ${resp.localPageLocationDocumentsAddedOrUploaded} Local Pages`);
            })
            .catch(e => {
                this.setState({fileUploading: false})
                this.setState({ errorMessage: e.response.data.exception })
                this.setState({ buttonEnabled: false });
                ToastService.error(`Error Uploading File: ${e.response.data.exception}`);
            })
    };

    // File content to be displayed after
    // file upload is complete
    fileData = () => {

        if (this.state.selectedFile) {

            return (
                <div>
                    <h4>File Details:</h4>
                    <p>File Name: {this.state.selectedFile.name}</p>
                </div>
            );
        } else {
            return <Fragment />
        }
    };

    render() {
        return (
            <div>
                <div className="card card-spacer-top">
                    <div className="card-header border-bottom">
                        <div className="d-flex align-items-center justify-content-between ">
                            <div className="form-group d-flex align-items-center">
                                <h4>File Uploader</h4>
                            </div>
                        </div>
                        <span className="admin-button pull-right"/>
                    </div>
                    <div className="d-flex align-items-start card-body card-footerless flex-column">
                        <div className="form-group mb-0">
                            <div><input type="file" onChange={this.onFileChange} /></div>
                            {this.state.fileUploading && <div className="text-center">
                                <h4 className="loading">Loading... </h4>
                                <i className="fas fa-spinner fa-spin fa-2x"/>
                            </div>}
                        </div>
                        <button disabled={!this.state.buttonEnabled} className="btn btn-secondary content-spacer-top" onClick={this.onFileUpload}>
                            Upload
                        </button>
                    </div>
                    {/* {
                        !!this.state.errorMessage && ToastService.error("Updates saved successfully. Reports will refresh to reflect changes within 24 hours.");
                        (!!this.state.errorMessage || !!this.state.successCountMessage) && <div className="form-group d-flex align-items-center card-footer mb-0">
                            {!!this.state.errorMessage && <div className="alert alert-danger mb-0" style={{"display": "block"}}>
                                Error Uploading File: {this.state.errorMessage} </div>}
                            {!!this.state.successCountMessage && <div className="alert alert-success mb-0" style={{"display": "block"}}>
                                Successfully Added/Updated: {this.state.successCountMessage} Local Pages</div>}
                        </div>
                    } */}
                </div>
            </div>
        );
    }
}

export default LocalPagesUploader;